import { cn } from "@/lib/utils"
import { splitPlaceName } from "@/lib/place-name"

interface PlaceNameProps {
  name: string | null | undefined
  /**
   * Contexto municipal da parada ("Cascavel, PR"). Quando informado, a linha 1
   * vira a cidade e a linha 2 o lugar + endereço — ex.: "Cascavel / Havan, Av.
   * Tancredo Neves, Cascavel, PR".
   */
  cityName?: string | null
  /** Sobrescreve o secundário derivado do nome (quando nem `cityName` serve). */
  secondary?: string | null
  className?: string
  primaryClassName?: string
  secondaryClassName?: string
}

/**
 * Nome de lugar em duas linhas: cidade em destaque e o nome completo (ou o POI
 * + cidade, quando há `cityName`) abaixo. Sem secundário, renderiza uma linha só.
 */
export function PlaceName({
  name,
  cityName,
  secondary,
  className,
  primaryClassName,
  secondaryClassName,
}: PlaceNameProps) {
  const parts = splitPlaceName(name, cityName)
  const primary = parts.primary
  const secondaryText = secondary === undefined ? parts.secondary : secondary
  if (!primary) return null

  return (
    <span className={cn("inline-flex min-w-0 flex-col", className)}>
      <span className={cn("truncate", primaryClassName)}>{primary}</span>
      {secondaryText ? (
        <span className={cn("truncate text-xs font-normal text-muted-foreground", secondaryClassName)}>
          {secondaryText}
        </span>
      ) : null}
    </span>
  )
}
